import gql from "graphql-tag";

export const GET_PROJECT = gql`
  query project($id: ID!) {
    project(id: $id) {
      id
      code
      name
    }
  },
`;
